import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-row gap-1 align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "x: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "y: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "x: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "y: ", -1)
const _hoisted_6 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-delete" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-2",
    columns: this.columns,
    items: this.items
  }, {
    reviewCycleNode: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        options: this.getReviewCycleNodeOptions(item),
        modelValue: item.reviewCycleNodeId,
        "onUpdate:modelValue": ($event: any) => ((item.reviewCycleNodeId) = $event)
      }, null, 8, ["class", "options", "modelValue", "onUpdate:modelValue"])
    ]),
    textDropDown: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        options: this.contentOptions,
        modelValue: item.content,
        "onUpdate:modelValue": ($event: any) => ((item.content) = $event)
      }, null, 8, ["class", "options", "modelValue", "onUpdate:modelValue"])
    ]),
    textTextField: _withCtx(({ item }) => [
      _createVNode(_component_TextInput, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        modelValue: item.content,
        "onUpdate:modelValue": ($event: any) => ((item.content) = $event)
      }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])
    ]),
    comment: _withCtx(({ item }) => [
      _createVNode(_component_TextInput, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        modelValue: item.comment,
        "onUpdate:modelValue": ($event: any) => ((item.comment) = $event),
        maxlength: "80"
      }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])
    ]),
    realm: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CheckBox, {
          class: _normalizeClass(this.getClass(item)),
          mode: "flex",
          modelValue: item.usedForRealm,
          "onUpdate:modelValue": ($event: any) => ((item.usedForRealm) = $event)
        }, null, 8, ["class", "modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_NumberInput, {
          class: _normalizeClass(this.getClass(item)),
          mode: "flex",
          modelValue: item.realmSequence,
          "onUpdate:modelValue": ($event: any) => ((item.realmSequence) = $event)
        }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])
      ])
    ]),
    lowerLeft: _withCtx(({ item }) => [
      _createElementVNode("div", {
        class: _normalizeClass([this.getClass(item), "d-flex flex-row align-items-center"])
      }, [
        _hoisted_2,
        _createVNode(_component_NumberInput, {
          class: "ms-1 me-2",
          mode: "flex",
          step: "0.1",
          modelValue: item.llx,
          "onUpdate:modelValue": ($event: any) => ((item.llx) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _hoisted_3,
        _createVNode(_component_NumberInput, {
          class: "ms-1 me-1",
          mode: "flex",
          step: "0.1",
          modelValue: item.lly,
          "onUpdate:modelValue": ($event: any) => ((item.lly) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ], 2)
    ]),
    upperRight: _withCtx(({ item }) => [
      _createElementVNode("div", {
        class: _normalizeClass([this.getClass(item), "d-flex flex-row align-items-center"])
      }, [
        _hoisted_4,
        _createVNode(_component_NumberInput, {
          class: "ms-1 me-2",
          mode: "flex",
          step: "0.1",
          modelValue: item.urx,
          "onUpdate:modelValue": ($event: any) => ((item.urx) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _hoisted_5,
        _createVNode(_component_NumberInput, {
          class: "ms-1 me-1",
          mode: "flex",
          step: "0.1",
          modelValue: item.ury,
          "onUpdate:modelValue": ($event: any) => ((item.ury) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ], 2)
    ]),
    font: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        options: this.fontOptions,
        modelValue: item.font,
        "onUpdate:modelValue": ($event: any) => ((item.font) = $event)
      }, null, 8, ["class", "options", "modelValue", "onUpdate:modelValue"])
    ]),
    fontSize: _withCtx(({ item }) => [
      _createVNode(_component_NumberInput, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        modelValue: item.fontPtsize,
        "onUpdate:modelValue": ($event: any) => ((item.fontPtsize) = $event)
      }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])
    ]),
    fontStyle: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        options: this.fontStyleOptions,
        modelValue: item.fontStyle,
        "onUpdate:modelValue": ($event: any) => ((item.fontStyle) = $event)
      }, null, 8, ["class", "options", "modelValue", "onUpdate:modelValue"])
    ]),
    alignment: _withCtx(({ item }) => [
      _createVNode(_component_Select, {
        class: _normalizeClass(this.getClass(item)),
        mode: "flex",
        options: this.alignmentOptions,
        modelValue: item.alignment,
        "onUpdate:modelValue": ($event: any) => ((item.alignment) = $event)
      }, null, 8, ["class", "options", "modelValue", "onUpdate:modelValue"])
    ]),
    choose: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_6, [
        (this.selectedSourceReviewCycleId == item.reviewCycleId)
          ? (_openBlock(), _createBlock(_component_CheckBox, {
              key: 0,
              mode: "flex",
              modelValue: item.selected,
              "onUpdate:modelValue": ($event: any) => ((item.selected) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn ms-3 mb-2",
          onClick: _withModifiers(($event: any) => (_ctx.$emit('removeTextField',item)), ["prevent"])
        }, _hoisted_9, 8, _hoisted_7)
      ])
    ]),
    _: 1
  }, 8, ["columns", "items"]))
}